import {
  createApp,
} from 'vue';

import App from './App.vue'

import './assets/bootstrap.scss'
const app = createApp(App);

import { createPinia } from 'pinia';
const pinia = createPinia();
app.use(pinia);

import Router from './router.js';
app.use(Router);

app.mount('#app');
